import { render, staticRenderFns } from "./family-info.vue?vue&type=template&id=125ba98b&"
import script from "./family-info.vue?vue&type=script&lang=js&"
export * from "./family-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports